import React from 'react'
import { numberToWords, AmountInWords, company_logo } from '../../../../Utility/function';
const styles = {
    body: {
        width: "80mm",
        fontSize: "12px",
        fontFamily: "Arial, sans-serif",
        margin: "0 auto",
        padding: "5px",
        lineHeight: "1.1",
        textAlign: "center",
        background: "white",
    },
    textCenter: { textAlign: "center" },
    logo: { width: "50px", height: "auto", margin: "1px 0" },
    flexBetween: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
    },
    bold: { fontWeight: "bold" },
    bold2: { fontWeight: "bold", fontSize: "14px" },
    textStart: { textAlign: "left", fontSize: "11px !important" },
    textEnd: { textAlign: "right" },
    hr: { margin: "0px", width: "100%", opacity: 1, color: "black" },
    // hr: { border: ".8px solid black", margin: "1px 0", width: "100%" },
    table: {
        width: "100%",
        fontSize: "11px",
        borderCollapse: "collapse",
        textAlign: "center",
    },
    border: {
        border: "1px solid black",
        padding: "5px",
        marginTop: "2px",
        width: "100%",
    },
    borderbottom: { borderBottom: "1px solid black" },
    fontSize: { fontSize: "10px" },
};

const companyInfoD = {
    name: "Company Name",
    address: "P.O. Box 605/512, AL Khoudh Souq, Muscat, Sultanate of Oman",
    phone: "+968 91120555",
    email: "Sales@toptecno.com"
};
const ThermalModal = ({ ref, InvoiceDetail, Products, ReturnItem, Payment, paidAmount, companyInfo = companyInfoD }) => {
    console.log(Products)
    return (
        <div ref={ref} style={styles.body}>
            <div style={styles.textCenter}>
                <img
                    src={company_logo || "assets/images/tech_logo.webp"}
                    alt="Company Logo"
                    style={styles.logo}
                />
                <p className="mb-1 fw-bold">
                    {companyInfo?.address}
                </p>
                <p className="mb-1 fw-bold">
                    Mobile: {companyInfo?.phone} | E-Mail: {companyInfo?.email}
                </p>
                <hr style={styles.hr} />
                <h6 style={styles.bold} className='mt-2'>INVOICE</h6>
                <h6 style={styles.bold} className='mt-1'>{InvoiceDetail.unique_id}</h6>
            </div>

            <div style={styles.textStart}>
                <div style={styles.flexBetween}>
                    <p className="mb-1 fw-bold">
                        <strong>Date:</strong> {InvoiceDetail.date}
                    </p>
                    <p className="mb-1 fw-bold">
                        <strong>LPO No:</strong> {InvoiceDetail?.lpo_no}
                    </p>
                </div>
                <hr style={styles.hr} />
            </div>

            <div style={styles.textStart} className='pt-2'>
                <h7 style={styles.bold2}>Customer</h7>
                <p className="mb-1 mt-2 fw-bold">
                    <strong>Name:</strong> {InvoiceDetail?.customer_name}
                </p>
                <p className="mb-1 fw-bold">
                    <strong>Phone:</strong> {InvoiceDetail?.customer_phone}
                </p>
                <p className="mb-2 fw-bold">
                    <strong>Address:</strong> {InvoiceDetail?.additional_details}
                </p>
                <hr style={styles.hr} />
            </div>

            <table style={styles.table}>
                <thead>
                    <tr style={styles.borderbottom}>
                        <th className="text-start" style={styles.textStart} >SL</th>
                        <th className="text-start">Item</th>
                        <th className="text-start">Qty</th>
                        <th className="text-start">Price</th>
                        <th className="text-start">Dis</th>
                        <th className="text-end">Amount</th>
                    </tr>
                </thead>
                {Array.isArray(Products) && Products.length > 0 && (
                    <tbody>
                        {Products?.map((item, index) => (
                            <tr key={index}>
                                <td className="text-start"><p style={styles.fontSize} className='mb-1 fw-bold'>{index + 1}</p></td>
                                <td className="text-start">
                                    <p className="mb-1 fw-bold" style={styles.fontSize}>
                                        {item.product_name}
                                    </p>
                                    {(() => {
                                        try {
                                            const serials = JSON.parse(item.serial_number);
                                            return (
                                                <p className="mb-1" style={{ fontSize: '8px', whiteSpace: 'pre-wrap' }}>
                                                    {serials.map(s => s.serial_number).join(', ')}
                                                </p>
                                            );
                                        } catch (e) {
                                            return null;
                                        }
                                    })()}
                                </td>
                                <td className="text-start">
                                    <p className="mb-1 fw-bold" style={styles.fontSize}>
                                        {item?.is_box == 1
                                            ? `${item.boxqty} (x${parseInt(item.qty) || 0 / parseInt(item.boxqty) || 0})`
                                            : item.qty}
                                    </p>
                                </td>
                                <td className="text-start ">
                                    <p className="mb-1 fw-bold" style={styles.fontSize}>
                                        {Number(item.sales_price).toFixed(2)}
                                    </p>
                                </td>
                                <td className="text-start ">
                                    <p className="mb-1 fw-bold" style={styles.fontSize}>
                                        {item.discount} {item.discount_type == 1 ? '%' : 'INR'}
                                    </p>
                                </td>
                                <td className="text-end">
                                    <p className="mb-1 fw-bold" style={styles.fontSize}>
                                        {Number(item.amount_per_price || item.sales_price * item.qty).toFixed(2)}
                                    </p>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                )}

                {/* {Array.isArray(ReturnItem) && ReturnItem.length > 0 && (
                    <tbody style={{ borderTop: "1px solid black" }}>
                        <tr>
                            <td colSpan="5" className="text-center">
                                <strong>Return Products</strong>
                            </td>
                        </tr>
                        {ReturnItem?.map((item, index) => (
                            <tr key={index}>
                                <td className="text-start">{index + 1}</td>
                                <td className="text-start">
                                    <p className="mb-1 fw-bold" style={styles.fontSize}>
                                        {item.product_name}
                                    </p>
                                </td>
                                <td className="text-start">
                                    <p className="mb-1 fw-bold" style={styles.fontSize}>
                                        {item.qty}
                                    </p>
                                </td>
                                <td className="text-start">
                                    <p className="mb-1 fw-bold" style={styles.fontSize}>
                                        {item.sales_price}
                                    </p>
                                </td>
                                <td className="text-end text-danger">
                                    <p className="mb-1 fw-bold" style={styles.fontSize}>
                                        -{item.amount_per_price}
                                    </p>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                )} */}
            </table>

            <hr style={styles.hr} />

            <div style={styles.textStart}>
                <div style={styles.flexBetween}>
                    <p className="mb-1 mt-2">
                        <strong>Sub Total:</strong>
                    </p>
                    <p className="mb-1 mt-2 fw-bold">
                        {Products
                            ?.reduce(
                                (acc, item) => acc + (parseFloat(item.amount_per_price) || 0),
                                0
                            )
                            .toFixed(2)}
                    </p>
                </div>
                <div style={styles.flexBetween}>
                    <p className="mb-1">
                        <strong>Discount:</strong>
                    </p>
                    <p className="mb-1 fw-bold">{InvoiceDetail?.discount}</p>
                </div>
                <div style={styles.flexBetween}>
                    <p className="mb-1">
                        <strong>VAT {InvoiceDetail.vat}%:</strong>
                    </p>
                    <p className="mb-1 fw-bold">
                        {(
                            (Products?.reduce(
                                (acc, item) => acc + (parseFloat(item.amount_per_price) || 0),
                                0
                            ) / 100) * InvoiceDetail.vat || 0
                        ).toFixed(2)}
                    </p>
                </div>
                {/* <div style={styles.flexBetween}>
                    <p className="mb-1">
                        <strong>Return:</strong>
                    </p>
                    <p className="mb-1 text-danger fw-bold">
                        -
                        {ReturnItem
                            ?.reduce(
                                (acc, item) => acc + (parseFloat(item.amount_per_price) || 0),
                                0
                            )
                            .toFixed(3)}
                    </p>
                </div> */}
                <div style={styles.flexBetween}>
                    <h6 style={styles.bold}>Grand Total:</h6>
                    <h6 style={styles.bold}>
                        {(
                            parseFloat(InvoiceDetail?.total || 0)
                            // -ReturnItem?.reduce(
                            //     (acc, item) => acc + (parseFloat(item.amount_per_price) || 0),
                            //     0
                            // )
                        ).toFixed(2)}
                    </h6>
                </div>
            </div>

            {InvoiceDetail.purchase_unit != 1 && (
                <>
                    <hr style={styles.hr} />
                    <div style={styles.textStart}>
                        <h6 style={styles.bold}>Payment History:</h6>
                        {Payment
                            ?.filter((item) => item.mop != "2")
                            ?.map((item, index) => (
                                <div key={index} style={styles.flexBetween}>
                                    <p className="mb-1 fw-bold">
                                        {item.date} ({item.mop == "1" ? "Cash" : item.mop == "4" ? "Card" : ""})
                                    </p>
                                    <p className="mb-1 fw-bold">{item.amount}</p>
                                </div>
                            ))}
                        <div style={styles.flexBetween}>
                            <h6 style={styles.bold}>Remaining Balance:</h6>
                            <h6 style={styles.bold} className="text-danger">
                                {(
                                    (
                                        parseFloat(InvoiceDetail?.total || 0)
                                        // - ReturnItem?.reduce(
                                        //     (acc, item) =>
                                        //         acc +
                                        //         (parseFloat(item.amount_per_price) || 0),
                                        //     0
                                        // )
                                    ) - parseFloat(paidAmount || 0)
                                ).toFixed(2)}
                            </h6>
                        </div>
                    </div>
                </>
            )}

            <hr style={styles.hr} />
            <div style={styles.textStart}>
                <p className="mb-1 fw-bold">
                    <strong>Amount In Words:</strong>
                    {/* {numberToWords(
                        (
                            parseFloat(InvoiceDetail?.total || 0) 
                            // -
                            // ReturnItem?.reduce(
                            //     (acc, item) => acc + (parseFloat(item.amount_per_price) || 0),
                            //     0
                            // )
                        ).toFixed(3)
                    )} Riyal Only */}
                    {AmountInWords(InvoiceDetail?.total)}

                </p>
                <hr style={styles.hr} />
                <p className="mb-1 mt-1 text-center fw-bold">
                    Thank you for your business!
                </p>
            </div>
        </div>
    )
}

export default ThermalModal